import React from 'react';
import { Link } from '../Link';
import { SideNav } from './SideNav';

export const Header = ({noprint}) => (
  <div id="header" className={noprint ? "noprint" : ''}>
    <div className="logo" />
    <div className="brand">
      <Link href="/">Foothill Community Democrats</Link>
    </div>
    <div className="links">
      <div className="facebook">
        <a href="https://www.facebook.com/FoothillCommunityDemocrats/">Connect with us on Facebook</a>
      </div>
      <div className="actblue">
        <a href="https://secure.actblue.com/donate/foothill-community-democrats-2">Donate on ActBlue</a>
      </div>
      <div className="lacdp">
        <a href="http://www.lacdp.org/democratic-club/">Other Local Democratic Clubs</a>
      </div>
    </div>
  </div>
);

export class MobileHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.onToggle = this.onToggle.bind(this);
  }

  onToggle() {
    this.setState({ open: !this.state.open });
  }

  render() {
    return (
      <div id="mobileHeader">
        <div className={"hamburgerMenu" + (this.state.open ? ' open' : '')}>
          <span onClick={this.onToggle}>{'\u2630'}</span>
          { this.state.open ? <SideNav current={this.props.current} onClose={() => this.setState({ open: false })} /> : null }
        </div>
        <div className="brand">
          <Link href="/">FCD</Link>
        </div>
      </div>
    );
  }
}
